import React from 'react';
import { InputLabelLayoutProps, useFormContext } from 'ui-builder';
import { cn } from 'shadcn-ui';

export default function ShadcnInputLabelLayout(props: InputLabelLayoutProps) {
  const formContext = useFormContext();

  const showRequiredIcon = props.showRequiredIcon !== undefined ? props.showRequiredIcon : true;

  if (!props.hideLabel) {
    return (
      <label
        className={cn(
          'flex items-center gap-2 text-base leading-none font-medium text-gray-600 select-none',
          props.bold && 'font-bold',
          props.className,
        )}
        data-testid={props.testID}
      >
        {props.label}
        {props.afterLabelElement}
        {showRequiredIcon
          && formContext.isFieldRequired
          && formContext.isFieldRequired(props.name)
          && (<span className="text-rose-600">*</span>)}
      </label>
    );
  } else {
    return null;
  }
}
